import footerController from './footer.controller.js';

function pageFooter() {
    return {
        template :require('./bcb.pageFooter.html'),
		controller: footerController
    };
};
export default pageFooter;



// WEBPACK FOOTER //
// ./src/login/footer/bcb.pageFooter.js